"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const i18next_1 = __importDefault(require("i18next"));
const setYupLocale_1 = __importDefault(require("./setYupLocale"));
const i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
const DETECTION_OPTIONS = {
  order: ['navigator']
};
i18next_1.default.use(i18next_browser_languagedetector_1.default);
function prepareLocale(language) {
  return __awaiter(this, void 0, void 0, function* () {
    const loadLocale = () => __awaiter(this, void 0, void 0, function* () {
      let detectedLanguage = language || i18next_1.default.language.split('-')[0];
      if (!['en', 'ru'].includes(detectedLanguage)) {
        detectedLanguage = 'en';
      }
      if (!i18next_1.default.hasResourceBundle(detectedLanguage, 'translation')) {
        let localeBundle;
        switch (detectedLanguage) {
          case 'en':
            localeBundle = yield Promise.resolve().then(() => __importStar(require('../en')));
            break;
          default:
            localeBundle = yield Promise.resolve().then(() => __importStar(require('../ru')));
        }
        i18next_1.default.addResourceBundle(detectedLanguage, 'translation', localeBundle.default);
      }
      void i18next_1.default.changeLanguage(detectedLanguage);
      (0, setYupLocale_1.default)();
    });
    if (!i18next_1.default.isInitialized) {
      void i18next_1.default.init({
        detection: DETECTION_OPTIONS,
        debug: process.env.NODE_ENV === 'development',
        fallbackLng: 'en',
        simplifyPluralSuffix: false
      }, loadLocale);
    } else {
      yield loadLocale();
    }
  });
}
exports.default = prepareLocale;